// extracted by mini-css-extract-plugin
export default {"emphasisText":"HeroButton_emphasisText__50VCv"};